import { useEffect, useState } from "react";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SummaryApi from "../common";
import { request } from "../helpers/request";

const WishlistButton = ({ productId, className = "" }) => {
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();

  const checkStatus = async () => {
    if (!user?._id) return;
    try {
      const response = await request(
        `${SummaryApi.checkWishlist.url}?productId=${productId}`,
        {
          method: SummaryApi.checkWishlist.method,
        },
      );
      const dataResponse = await response.json();
      if (dataResponse.success) {
        setIsInWishlist(dataResponse.inWishlist);
      }
    } catch (error) {
      console.error("Error checking wishlist status:", error);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    checkStatus();
  }, [productId, user]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleToggleWishlist = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!user?._id) {
      toast.info("Please login to use wishlist");
      navigate("/login");
      return;
    }

    setLoading(true);
    try {
      const apiCall = isInWishlist
        ? SummaryApi.removeFromWishlist
        : SummaryApi.addToWishlist;
      const response = await request(apiCall, {
        body: JSON.stringify({ productId }),
      });
      const dataResponse = await response.json();

      if (dataResponse.success) {
        setIsInWishlist(!isInWishlist);
        toast.success(dataResponse.message);
      } else {
        toast.error(dataResponse.message);
      }
    } catch (error) {
      toast.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggleWishlist}
      disabled={loading}
      className={`transition-all duration-300 active:scale-90 ${className}`}
      aria-label={isInWishlist ? "Remove from wishlist" : "Add to wishlist"}
      aria-pressed={isInWishlist}
      title={isInWishlist ? "Remove from wishlist" : "Add to wishlist"}
    >
      {isInWishlist ? (
        <FaHeart className="text-red-500" />
      ) : (
        <FaRegHeart className="text-gray-400 group-hover:text-red-500 transition-colors" />
      )}
    </button>
  );
};

export default WishlistButton;
